customElements.whenDefined('cart-drawer-items').then(() => {
  if (typeof CartItems !== 'undefined' && CartItems.prototype.onChange) {
    const _cartItemsOnChange = CartItems.prototype.onChange;
    CartItems.prototype.onChange = function (event) {
      if (event.target.classList.contains('gift-bag-item-input')) return;
      _cartItemsOnChange.call(this, event);
    };
  }
});

document.addEventListener('DOMContentLoaded', function() {
  function adjustSelectWidth(select) {
    if (!select) return;

    const tempSelect = document.createElement('select');
    const tempOption = document.createElement('option');
    tempSelect.style.cssText = 'position:absolute;visibility:hidden;width:auto;';
    tempSelect.appendChild(tempOption);
    document.body.appendChild(tempSelect);

    let maxWidth = 0;
    for (let i = 0; i < select.options.length; i++) {
      tempOption.textContent = select.options[i].text;
      const width = tempSelect.offsetWidth;
      if (width > maxWidth) maxWidth = width;
    }

    document.body.removeChild(tempSelect);
    select.style.width = (maxWidth + 40) + 'px';
  }

  const sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    adjustSelectWidth(sortSelect);
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        const newSortSelect = document.getElementById('SortBy');
        if (newSortSelect) {
          adjustSelectWidth(newSortSelect);
        }
      }
    });
  });

  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    observer.observe(productGridContainer.parentElement, {
      childList: true,
      subtree: true
    });
  }
});

(function () {
  let isProcessing = false;

  function localRefreshCartDrawer() {
    fetch('/cart?sections=cart-drawer')
      .then(res => res.json())
      .then(data => {
        if (data['cart-drawer']) {
          const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          const newContent = html.querySelector('cart-drawer');
          const currentDrawer = document.querySelector('cart-drawer');
          if (newContent && currentDrawer) {
            currentDrawer.innerHTML = newContent.innerHTML;
            const overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
            if (overlay) overlay.addEventListener('click', currentDrawer.close.bind(currentDrawer));
            if (typeof updateButtonsState === 'function') updateButtonsState();
            if (typeof updateCheckoutConsentState === 'function') updateCheckoutConsentState(document);
            setTimeout(() => {
              initGiftBagItems();
              if (window.initCartDrawerValidation) window.initCartDrawerValidation();
              isProcessing = false;
            }, 100);
          } else {
            isProcessing = false;
          }
        } else {
          isProcessing = false;
        }
      })
      .catch(err => {
        console.error('localRefreshCartDrawer error:', err);
        isProcessing = false;
      });
  }

  async function initGiftBagItems() {
    const wrappers = Array.from(document.querySelectorAll('.gift-bag-item-wrapper'))
      .filter(w => w.dataset.initialized !== 'true');
    if (!wrappers.length) return;

    let initialCart = null;
    try {
      const res = await fetch('/cart.js');
      initialCart = await res.json();
    } catch (e) {
      console.error('initGiftBagItems:', e);
    }

    wrappers.forEach((wrapper) => {
      if (wrapper.dataset.initialized === 'true') return;
      const checkbox = wrapper.querySelector('.gift-bag-item-input');
      const itemKey = wrapper.dataset.itemKey;
      const giftVariantId = wrapper.dataset.giftVariantId;

      if (!checkbox || !giftVariantId) return;
      wrapper.dataset.initialized = 'true';

      if (initialCart) {
        const existing = initialCart.items.find(i =>
          i.properties &&
          i.properties['_is_gift_bag'] === 'true' &&
          i.properties['_gift_for_item'] === itemKey
        );
        if (existing) checkbox.checked = true;
      }

      async function removeGiftForItem() {
        try {
          const res = await fetch('/cart.js');
          const cart = await res.json();
          const giftItem = cart.items.find(i =>
            i.properties &&
            i.properties['_is_gift_bag'] === 'true' &&
            i.properties['_gift_for_item'] === itemKey
          );
          if (giftItem) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: giftItem.key, quantity: 0 })
            });
            return true;
          }
          return false;
        } catch (e) {
          console.error('removeGiftForItem:', e);
          return false;
        }
      }

      async function addGiftForItem() {
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: parseInt(giftVariantId, 10),
              quantity: 1,
              properties: { '_is_gift_bag': 'true', '_gift_for_item': itemKey }
            })
          });
          return true;
        } catch (e) {
          console.error('addGiftForItem:', e);
          return false;
        }
      }

      checkbox.addEventListener('change', async function (e) {
        e.stopPropagation();
        if (isProcessing) { this.checked = !this.checked; return; }
        isProcessing = true;
        wrapper.classList.add('updating');

        if (this.checked) {
          await removeGiftForItem();
          const added = await addGiftForItem();
          if (added) {
            localRefreshCartDrawer();
          } else {
            this.checked = false;
            isProcessing = false;
            wrapper.classList.remove('updating');
          }
        } else {
          const removed = await removeGiftForItem();
          if (removed) {
            localRefreshCartDrawer();
          } else {
            this.checked = true;
            isProcessing = false;
            wrapper.classList.remove('updating');
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftBagItems);
  } else {
    initGiftBagItems();
  }

  const observer = new MutationObserver((mutations) => {
    let shouldInit = false;
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        const hasGiftBag = Array.from(mutation.addedNodes).some(node =>
          node.nodeType === 1 && (
            node.classList?.contains('gift-bag-item-wrapper') ||
            node.querySelector?.('.gift-bag-item-wrapper')
          )
        );
        if (hasGiftBag) { shouldInit = true; break; }
      }
    }
    if (shouldInit) {
      setTimeout(() => {
        initGiftBagItems();
        if (window.initCartDrawerValidation) window.initCartDrawerValidation();
      }, 100);
    }
  });

  const startObserving = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { childList: true, subtree: true });
      initGiftBagItems();
    } else {
      setTimeout(startObserving, 500);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }

  window.initGiftBagItems = initGiftBagItems;
})();
